import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";

import { useAdminMeQuery } from "@/features/api";

/** Admin cookie'si HttpOnly; oturum `GET /admin/auth/me` ile doğrulanır. */
export function RequireAdmin() {
  const location = useLocation();
  const { data, isLoading } = useAdminMeQuery();

  if (data) return <Outlet />;
  if (isLoading) return <FullPageSpinner />;

  const search =
    location.pathname !== "/" ? `?from=${encodeURIComponent(location.pathname)}` : "";
  return <Navigate to={`/login${search}`} replace />;
}

/**
 * Oturum açıkken login/şifre sayfalarına düşmesin. Kod doğrulanınca `me` cache'e
 * yazılır ve yönlendirmeyi bu guard yapar.
 */
export function PublicOnly() {
  const [searchParams] = useSearchParams();
  const { data, isLoading } = useAdminMeQuery();

  if (isLoading) return <FullPageSpinner />;
  if (data) {
    const from = searchParams.get("from");
    const target = from && from.startsWith("/") && !from.startsWith("//") ? from : "/";
    return <Navigate to={target} replace />;
  }
  return <Outlet />;
}

export function FullPageSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted-foreground/20 border-t-foreground" />
    </div>
  );
}
